import { render } from "./DotsHorizontal.vue.js?vue&type=template&id=a8ba8946!=!../vue-loader/dist/index.js??ruleSet[0]!./DotsHorizontal.vue?vue&type=template&id=a8ba8946"
import script from "./DotsHorizontal.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./DotsHorizontal.vue?vue&type=script&lang=js"
export * from "./DotsHorizontal.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./DotsHorizontal.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__